import React from 'react';
import { Tabs } from 'antd';
import { useLocation, useHistory } from 'react-router-dom';
import { Switch, Route, Redirect } from 'react-router-dom';
import './styles.css';

import { CampaignOrderQueueQueued } from './CampaignOrderQueueQueued';
import { CampaignOrderQueueReady } from './CampaignOrderQueueReady';
import { CampaignOrderDraft } from './CampaignOrderQueueDraft';
import { CampaignOrderLaunched } from './CampaignOrderQueueLaunched';
import { CampaignOrderQueueProgrammatic } from './CampaignOrderQueueProgrammatic';

export const CampaignOrderQueue = () => {
  const location = useLocation();
  const history = useHistory();

  // Determine the active tab based on the route
  const getActiveKey = () => {
    switch (location.pathname) {
      case '/campaigns/v2/orderqueue/launched':
        return '1';
      case '/campaigns/v2/orderqueue/launching':
        return '2';
      case '/campaigns/v2/orderqueue/ready-to-launched':
        return '4';
      case '/campaigns/v2/orderqueue/queued':
        return '5';
      case '/campaigns/v2/orderqueue/draft':
        return '6';
      default:
        return '1'; // Default to "Launched" if no match is found
    }
  };

  const handleTabChange = (key) => {
    switch (key) {
      case '1':
        history.push('/campaigns/v2/orderqueue/launched');
        break;
      case '2':
        history.push('/campaigns/v2/orderqueue/launching');
        break;
      case '4':
        history.push('/campaigns/v2/orderqueue/ready-to-launched');
        break;
      case '5':
        history.push('/campaigns/v2/orderqueue/queued');
        break;
      case '6':
        history.push('/campaigns/v2/orderqueue/draft');
        break;
      default:
        history.push('/campaigns/v2/orderqueue/launched');
        break;
    }
  };

  return (
    <div>
      <Tabs
        style={{ padding: '8px 24px' }}
        activeKey={getActiveKey()}
        onChange={handleTabChange}
        className="campaign-order-queue-tabs"
        items={[
          { key: '1', label: 'In Flight' },
          { key: '2', label: 'Programmatic' },
          { key: '4', label: 'Ready' },
          { key: '5', label: 'In Review' },
          { key: '6', label: 'Draft' },
        ]}
      />

      <div style={{ padding: '24px' }}>
        <Switch>
          <Route path="/campaigns/v2/orderqueue/launched" exact component={CampaignOrderLaunched} />
          <Route
            path="/campaigns/v2/orderqueue/launching"
            exact
            component={CampaignOrderQueueProgrammatic}
          />
          <Route
            path="/campaigns/v2/orderqueue/paused"
            exact
            render={() => <Redirect to="/campaigns/v2/orderqueue/launched" />}
          />
          <Route
            path="/campaigns/v2/orderqueue/ready-to-launched"
            exact
            component={CampaignOrderQueueReady}
          />
          <Route
            path="/campaigns/v2/orderqueue/queued"
            exact
            component={CampaignOrderQueueQueued}
          />
          <Route path="/campaigns/v2/orderqueue/draft" exact component={CampaignOrderDraft} />
          {/* Add wildcard path */}
          <Route
            path="/campaigns/v2/orderqueue/*"
            render={() => <Redirect to="/campaigns/v2/orderqueue/launched" />}
          />
        </Switch>
      </div>
    </div>
  );
};
